import { model } from 'helpers/model';

const taskModel = {
  fields: ['selectedFile', 'buildId', 'libraryIds', 'parameters'],

  requiredFields: ['selectedFile', 'buildId'],

  initialValues: {},

  validate(values) {
    return {}; // validation exists at field level for 'parameters' / 'libraryIds'
  }
};

export default model(taskModel);



// WEBPACK FOOTER //
// ./src/client/modules/engine-tasks/model.js